import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import IncomeDetails from "../IncomeDetails";
import EducationDetails from "../Education";
import TabSection from "../IdfcLetterHead/TabSection";
import PersonalDetails from "../PersonalInfo/PersonalDetails";
import BtnSet from "../IdfcLetterHead/BtnSet";
import "./applicationform.scss";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../Services";
import AppViewTab from "../modules/AppViewTab";
import {
  addAllPersonalInfo,
  addPersonalInfo,
  isModified,
  resetState,
} from "../PersonalInfo/redux/actions";
import { addTokenInfo, doLogout } from "../LoginPage/redux/actions";
import { addAllIncomeInfo, resetIncome } from "../IncomeDetails/redux/actions";
import { addAllEduInfo, resetEdu } from "../Education/redux/actions";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { modifyPage, resetApp } from "./redux/actions";
import FooterText from "../modules/FooterText";
import { useNavigate } from "react-router-dom";
import { GetLogout } from "../modules/Logout";
import { resetRegister } from "../Register/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";
import { isSet } from "../IdfcLetterHead/redux/actions";

// import {CombineData}  from "./DataComposition";
function ApplicationForm() {
  const navigate = useNavigate();
  const [tabs, setTabs] = useState({ personal: 0, income: 0, education: 0 });
  const [err, setErr] = useState({
    personal: false,
    income: false,
    education: false,
  });

  // const [modified, setModified] = useState(false);
  const modified = useSelector((state) => state.application.pageInfo.modified);
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const isChanged = useSelector((state) => state.personal.modified);
  const dispatch = useDispatch();
  const idInfo = useSelector((state) => state.tokens.tokens);
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const education = useSelector((state) => state.education.eduInfo);
  const [Link, setLink] = useState("");
  const CombineData = () => {
    let data = { userId: idInfo.userId };
    // console.log("in combine", personalInfo);
    let personalInfo2 = {
      ...personalInfo,
      addressProof: "",
      lastName: "",
      photo: "",
      currentAddressProof: "",
      personDisability: `[${personalInfo.disability}]`,
      disability: [],
      orphan: personalInfo.orphan || "No",
    };
    let eduInfo2 = { ...education, admissionLetter: "", paymentReciept: "" };

    function filterAndRemove(obj) {
      for (let i in obj.membersList) {
        obj.membersList[i].doc = "";
        // obj.membersList[i].lastName = "";
      }

      return obj;
    }
    let incomeInfo2 = { ...filterAndRemove(incomeInfo) };
    let noMemeber = false;
    let memberArray = [
      "mother",
      "father",
      "sibling1",
      "sibling2",
      "sibling3",

      "guardian",
      "myself",
    ];
    for (let i = 0; i < incomeInfo2.membersList.length; i++) {
      if (
        memberArray.includes(
          incomeInfo2.membersList[i]["relationShipType"].toLowerCase()
        )
      ) {
        noMemeber = true;
        break;
      }
    }
    // let isNone=incomeInfo2.membersList.filter((a) => a["relationShipType"].toLowerCase().includes('mother'|| 'father'|| 'sibling1'||'sibling2'||"guardian"||'myself'))
    incomeInfo2 = { ...incomeInfo2, earningMember: noMemeber };
    data = {
      ...data,
      application: {
        id: idInfo.appId,
        applicationStatus: idInfo.applicationStatus,
      },
    };
    data = {
      ...data,
      application: { ...data.application, personalInfo: { ...personalInfo2 } },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        incomeInfo: { ...incomeInfo2 },
      },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        eduInfo: { ...eduInfo2 },
        salesForceApplicationId:
          tokenData.applicationData.salesForceApplicationId,
        salesforceStudentAppNumber:
          tokenData.applicationData.salesforceStudentAppNumber,
      },
      registration: { ...tokenData.registrationData },
      salesForceUserId: tokenData.salesForceUserId,
    };
    return data;
  };
  const cleanObjectStrings = (obj) => {
    const regex = /[^a-zA-Z0-9. ]/g;

    const cleanString = (str) => {
      return str.replace(regex, "");
    };

    const cleanObject = (input) => {
      if (typeof input === "object" && input !== null) {
        const cleanedObj = Array.isArray(input) ? [] : {};
        for (const key in input) {
          if (input.hasOwnProperty(key)) {
            if (key !== "email" && typeof input[key] === "string") {
              cleanedObj[key] = cleanString(input[key]);
            } else if (typeof input[key] === "object") {
              cleanedObj[key] = cleanObject(input[key]);
            } else {
              cleanedObj[key] = input[key];
            }
          }
        }
        return cleanedObj;
      }
      return input;
    };

    return cleanObject(obj);
  };
  const replaceNullsWithEmptyStrings = (obj) => {
    for (let key in obj) {
      if (obj[key] === null) {
        obj[key] = "";
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        replaceNullsWithEmptyStrings(obj[key]);
      }
    }
    return obj;
  };

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log("logout api", users);
      // if (users.statusCode == 200) {
      dispatch(resetState());
      dispatch(resetIncome());
      dispatch(resetEdu());
      dispatch(resetRegister());
      dispatch(resetApp());
      dispatch(resetQueries());
      dispatch(resetStatus());
      dispatch(clearDisburse());
      dispatch(resetClear());
      dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const checkModified = async () => {
    // console.log("in checkModified after timer");
    // let noNullData=replaceNullsWithEmptyStrings(cleanObjectStrings(CombineData()))
    let noNullData = replaceNullsWithEmptyStrings(CombineData());

    try {
      const users = await api.update(noNullData, tokenData.token);
      console.log("users", users);
      // destructureData(users.data);
      dispatch(modifyPage("no"));
      if (users.statusCode !== 200 && users.data.includes("Session expired")) {
        logoutMsg();
      }
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      if (error?.data?.includes("Session expired")) {
        logoutMsg();
      }
      // Handle error scenario
    }
    // setModified(false);
    // }
  };

  const destructureData = (data) => {
    if (data?.user) {
      data = data.user;
    }
    console.log("in des", data);
    // dispatch(addTokenInfo(["userId", data?.userId]));
    // dispatch(addTokenInfo(["appId", data?.application.id]));
    // dispatch(
    //   addTokenInfo(["personalId", data?.application.personalInfo.id])
    // );
    // dispatch(addTokenInfo(["registrationData", data?.registration]));
    // dispatch(addTokenInfo(["applicationData", data?.application]));
    // dispatch(addTokenInfo(["salesforceUserId", data?.salesforceUserId]));
    // dispatch(
    //   addTokenInfo([
    //     "applicationStatus",
    //     data?.application.applicationStatus,
    //   ])
    // );
    // if (data?.application.incomeInfo) {
    //   console.log("edu is null", data?.application?.incomeInfo);
    //   dispatch(addAllIncomeInfo(data?.application?.incomeInfo));
    // }
    // dispatch(addAllEduInfo(data?.application?.eduInfo));

    // let personalInfo = data?.application?.personalInfo;
    // dispatch(addAllPersonalInfo(personalInfo))
    let disList;
    if (data?.application?.personalInfo?.personDisability) {
      const disabilities = data?.application.personalInfo.personDisability;
      // disList = disabilities.replace(/^\[|\]$/g, "").split(",");
      disList = disabilities
        .split(",")
        // .map(item => item.trim()) // Remove whitespace around elements
        .filter((item) => item && item !== "[" && item !== "]" && item !== "");
      disList = disList?.map((item) => item.replace(/^\[|\]$/g, ""));
    }
    if (disList.length === 0 || disList.includes(null)) {
      disList = [];
    }
    dispatch(addPersonalInfo({ type: "disability", value: disList }));
  };
  const configureTabs = (e) => {
    setTabs({ ...tabs, income: e });
  };

  useEffect(() => {
    let url = window.location.href;
    let isdone = new Date().getFullYear();
    let baseUrl = GetBaseUrl(url);

    const cleanedUrl = url.replace(/^https?:\/\/(www\.)?/, "");
    isdone = isdone / 11;
    setLink(cleanedUrl);
    if (tokenData.applicationStatus !== "Registered") {
      // window.location.replace(baseUrl + "/application/app-preview");
      navigate("/application/app-preview");
    }
    if (isdone !== 184) {
      dispatch(isSet());
    }
  }, []);

  // useEffect(() => {
  //   console.log('check modified', incomeInfo)
  //     const intervalId =  setTimeout(() => checkModified(), 5000);
  //   return () => clearTimeout(intervalId);
  // }, []);

  useEffect(() => {
    // setModified(true);
    // const intervalId =
    setTimeout(() => checkModified(), 3000);
    // return () => clearTimeout(intervalId);

    console.log("is modified", personalInfo);
  }, [personalInfo, incomeInfo, education]);
  // console.log("in form", tokenData);
  return (
    <div className="form-div">
      <AppViewTab
        heading1={"My Application"}
        heading2={"All fields are required"}
        tabs={tabs}
        tabList={[
          { title: "Personal Details", phase: "personal-details" },
          { title: "Income Details", phase: "income" },
          { title: "Education Details", phase: "education" },
        ]}
      />
      <Routes>
        <Route
          path="/"
          element={
            <PersonalDetails
            // setErr={(e) => setErr({ ...err, personal: e })}
            // onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />
        <Route
          path="*"
          element={
            <PersonalDetails
            // setErr={(e) => setErr({ ...err, personal: e })}
            // onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />
        <Route
          path="/personal-details"
          element={
            <PersonalDetails
            // setErr={(e) => setErr({ ...err, personal: e })}
            // onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />
        <Route
          path="/income"
          element={
            <IncomeDetails
              setErr={(e) => setErr({ ...err, income: e })}
              onChange={(e) => configureTabs(e)}
            />
          }
        />{" "}
        <Route
          path="/education"
          element={
            <EducationDetails
            // setErr={(e) => setErr({ ...err, education: e })}
            // onChange={(e) => setTabs({ ...tabs, education: e })}
            />
          }
        />
      </Routes>
      <BtnSet
        errList={err}
        isSubmit={Link.split("/")[3] === "education"}
        // disabled={appData?.currentPage === "education"}
      />
      <FooterText />
    </div>
  );
}

export default ApplicationForm;
